module.exports = __webpack_public_path__ + "img/18600.d728cadf.jpg";